import { FetchResult, MutationFunctionOptions } from '@apollo/client';
import {
  CreateTelegramStarsInvoiceLinkMutation,
  CreateTelegramStarsInvoiceLinkMutationVariables,
  useCreateTelegramStarsInvoiceLinkMutation,
} from './gql/createTelegramStarsInvoiceLink.generated';

type TUseCreateTelegramStarsInvoiceLink = () => {
  loading: boolean;
  createTelegramStarsInvoiceLink: (
    options?: MutationFunctionOptions<
      CreateTelegramStarsInvoiceLinkMutation,
      CreateTelegramStarsInvoiceLinkMutationVariables
    >,
  ) => Promise<FetchResult<CreateTelegramStarsInvoiceLinkMutation>>;
};

export const useCreateTelegramStarsInvoiceLink: TUseCreateTelegramStarsInvoiceLink = () => {
  const [createTelegramStarsInvoiceLink, { loading }] = useCreateTelegramStarsInvoiceLinkMutation();

  const wrappedCreateTelegramStarsInvoiceLink = async (
    options?: MutationFunctionOptions<
      CreateTelegramStarsInvoiceLinkMutation,
      CreateTelegramStarsInvoiceLinkMutationVariables
    >,
  ) => {
    try {
      const result = await createTelegramStarsInvoiceLink(options);
      return result;
    } catch (err) {
      console.error('❌ [GraphQL] createTelegramStarsInvoiceLink mutation failed:', err);
      throw err;
    }
  };

  return {
    loading,
    createTelegramStarsInvoiceLink: wrappedCreateTelegramStarsInvoiceLink,
  };
};
